module.exports = __webpack_public_path__ + "img/未标题-15.b2af5e27.png";